import React, { useMemo } from "react";
import {
  getComponentsCard,
  getComponentsFromBlockItems,
} from "@companion-core/shared/app/Utils/componentHelper";
import { BlockProps } from "@companion-core/shared/app/Interfaces/blocks";
import { ComponentData } from "@companion-core/shared/app/Interfaces/API";
import { GeolocationLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/GeolocationLayout/GeolocationLayout";

export const Geolocation = ({ simpleBlockItems }: BlockProps) => {
  const simpleComponents: ComponentData[] = useMemo(
    () => getComponentsFromBlockItems(simpleBlockItems),
    [simpleBlockItems]
  );
  const backgroundImage = useMemo(() => {
    return simpleComponents.find((component) => component.type === "media")?.medias?.[0]?.url;
  }, [simpleComponents]);
  const card: ComponentData = useMemo(
    () => getComponentsCard(simpleComponents)[0],
    [simpleComponents]
  );
  return (
    <GeolocationLayout
      mediaUrl={backgroundImage}
      iconUrl={card?.medias?.[0]?.url}
      iconDescriptionAlt={card?.medias?.[0]?.description_alt}
      title={card?.title}
      description={card?.description ?? undefined}
    />
  );
};
